import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import useOutsideClick from '@/hooks/useOutsideClick'

import * as S from './styles'

import type { ProfessionOptionDataType } from '@/types/components/ContactForm'

interface SelectProfessionProps {
  value?: ProfessionOptionDataType
  onChange?: (option: ProfessionOptionDataType) => void
  error?: boolean
}

const SelectProfession: React.FC<SelectProfessionProps> = ({
  value,
  onChange,
  error
}) => {
  const { t } = useTranslation()

  const options: ProfessionOptionDataType[] = [
    { value: '', label: t('contactPage.form.select') },
    // AQUI
    {
      value: 'course_coordinator',
      label: t('contactPage.form.professions.coordinator')
    },
    { value: 'professor', label: t('contactPage.form.professions.professor') },
    { value: 'analyst', label: t('contactPage.form.professions.student') },
    { value: 'others', label: t('contactPage.form.professions.others') }
  ]

  const [isOpen, setIsOpen] = useState(false)
  const dataSelectionRef = useRef<HTMLDivElement>(null)

  const selectedOption = value ?? options[0]

  const handleSelect = (option: ProfessionOptionDataType) => {
    setIsOpen(false)
    if (onChange) onChange(option)
  }

  const toggleDropdown = () => {
    setIsOpen(prev => !prev)
  }

  useOutsideClick(dataSelectionRef, () => setIsOpen(false))

  return (
    <S.Container>
      <label htmlFor="profession-select">
        {t('contactPage.form.profession')}
      </label>

      <S.SelectContainer ref={dataSelectionRef}>
        <S.SelectButton
          onClick={toggleDropdown}
          id="profession-select"
          error={!!error}
        >
          <S.SelectText hasValue={!!selectedOption.value}>
            {selectedOption.label}
          </S.SelectText>
          <S.ArrowIcon
            isOpen={isOpen}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </S.ArrowIcon>
        </S.SelectButton>

        <S.Dropdown isOpen={isOpen}>
          <S.DropdownList>
            {options.map(option => (
              <S.OptionButton
                key={option.value}
                onClick={() => handleSelect(option)}
                isSelected={selectedOption.value === option.value}
              >
                {option.label}
              </S.OptionButton>
            ))}
          </S.DropdownList>
        </S.Dropdown>
      </S.SelectContainer>
    </S.Container>
  )
}

export default SelectProfession
